import SoundEffect from "./SoundEffect";

export const SoundEffects = {
    /**
     * @constant
     * @type {SoundEffect}
     */
    buttonClick: new SoundEffect(1.0, "sound/effects/ui/Snd_click.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    coins: new SoundEffect(0.5, "sound/effects/coins/handleCoins.mp3",
            "sound/effects/coins/handleCoins2.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    tab: new SoundEffect(1.0, "sound/effects/ui/metalLatch.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    minionDeath: new SoundEffect(1.0, "sound/effects/deathMinion/bite-small.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    travelEffect: new SoundEffect(1.0, "sound/effects/travelEffect/dropLeather.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    deathBell: new SoundEffect(1.0, "sound/effects/deathBell/churchbell.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    deathScream: new SoundEffect(1.0, "sound/effects/deathScream/death_01.mp3",
            "sound/effects/deathScream/death_02.mp3",
            "sound/effects/deathScream/death_04.mp3",
            "sound/effects/deathScream/death_05.mp3",
            "sound/effects/deathScream/death_06.mp3",
            "sound/effects/deathScream/death_07.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    resurrection: new SoundEffect(1.0, "sound/effects/resurrection/JRPG_characterRevived.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    questCompletion: new SoundEffect(1.0, "sound/effects/questCompleted/Jingle_Achievement_00_128.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    collectibleFound: new SoundEffect(1.0, "sound/effects/collectibleFound/teleport_02.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    achievement: new SoundEffect(1.0, "sound/effects/achievement/cursespell.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    partyRankEarned: new SoundEffect(1.0, "sound/effects/partyRank/retro_beep_04.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    spellBlastEffect: new SoundEffect(1.0, "sound/effects/spellBlastArea/sfx_exp_cluster2.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard2.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard3.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard6.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard10.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard12.mp3",
            "sound/effects/spellBlastArea/sfx_exp_short_hard13.mp3",
            "sound/effects/spellBlastArea/missile_explosion.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    damage: new SoundEffect(1.0, "sound/effects/damage/sfx_exp_shortest_hard6.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft1.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft2.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft6.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft7.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft8.mp3",
            "sound/effects/damage/sfx_exp_shortest_soft9.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    doorOpenEffect: new SoundEffect(1.0, "sound/effects/doorOpen/sfx_movement_dooropen1.mp3",
            "sound/effects/doorOpen/doorOpen_1.mp3",
            "sound/effects/doorOpen/doorOpen_2.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    barrelOpen: new SoundEffect(1.0, "sound/effects/open/boots-leather-step-01.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    itemDrop: new SoundEffect(1.0, "sound/effects/itemDrop/water-drop-02.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    potBroken: new SoundEffect(1.0, "sound/effects/breakPot/wood-bowl-spoon-04.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    sackLooted: new SoundEffect(1.0, "sound/effects/sackLooted/knife-sheathe-01.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    chestOpen: new SoundEffect(1.0, "sound/effects/chestOpen/match-light-01.mp3",
            "sound/effects/chestOpen/quiver-leather-squeeze-01.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    fixtureBreak: new SoundEffect(1.0, "sound/effects/fixtureBreak/item_wood_02.mp3",
            "sound/effects/fixtureBreak/misc_03.mp3",
            "sound/effects/fixtureBreak/wood_01.mp3",
            "sound/effects/fixtureBreak/wood_04.mp3"),
    /**
     * @constant
     * @type {SoundEffect}
     */
    rareWeaponFound: new SoundEffect(1.0, "sound/effects/foundRare/levelup.mp3")
};